var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie"},[_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.resizeChart),expression:"resizeChart"}],staticClass:"commonRingItems",style:({width: _vm.width, height: _vm.height}),attrs:{"id":_vm.commonRingId}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b54dda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Echarts/Pie/Pie/commonRing.vue
// module id = null
// module chunks = 